import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return window.localStorage.getItem("tnpsc_lang") || "en";
  });

  useEffect(() => {
    window.localStorage.setItem("tnpsc_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.classList.toggle("lang-ta", lang === "ta");
    document.documentElement.classList.toggle("lang-en", lang === "en");
  }, [lang]);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
  return ctx;
};
